import styled, { css } from 'styled-components';
import SVG from 'react-inlinesvg';

export const Wrapper = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.tiny};
`;

export const Icon = styled(SVG)`
  width: 18px;
  height: 18px;
  margin-right: ${({ theme }) => theme.spacing.tiny};

  ${({ $error, theme }) =>
    $error &&
    css`
      color: ${theme.palette.errorBorder};
    `};
`;

export const Message = styled.span`
  font-size: ${({ theme }) => theme.fontsize.system};
  line-height: ${({ theme }) => theme.lineHeights.system};
`;
